module.exports = __webpack_public_path__ + "img/pic-1.2079092b.jpg";